import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { webConfig } from '../../webconfig';
import { Helpers } from '../../helpers';


@Injectable()
export class AuthenticationService {

    constructor(private http: Http, private config: webConfig) { }
    login(email: string, password: string) {
        let url = this.config.url + 'account/login/';
        let headers = new Headers({ 'Content-Type': 'application/json' });
        const options = new RequestOptions({ headers: headers });
        return this.http.post(url, { email: email, password: password }, options)
            .map(
                (res: Response) => {
                  
                    if (res) {
                        if (res.status === 201) {
                            return  res.json() 
                        }
                        else if (res.status === 200) {
                            return res.json() 
                        }
                        else if (res.status === 202) {
                            return res.json() 
                        }
                    }
               
                    
                }).catch((error: any) => {
                
                    if (error.status === 500) {
                        return Observable.throw(new Error(error.status));
                    }
                    else if (error.status === 400) {
                        return Observable.throw(new Error(error.status));
                    } else if (error.status === 409) {
                        return Observable.throw(new Error(error.status));
                    }
                    else if (error.status === 406) {
                        return Observable.throw(new Error(error.status));
                    }
                    Helpers.setLoading(false);
              
                });
    }
    isAuth() {
        const user = localStorage.getItem('currentUser');
        return !!user;
    }
    logout() {
        localStorage.removeItem('currentUser');
    }
}


// WEBPACK FOOTER //
// D:/Finca/Finca UI/UI/src/app/auth/_services/authentication.service.ts